import { axiosInstance } from ".";
import { REWARDS_TYPES } from "../../utils/Constants";

const getRewards = async (params) =>
  await axiosInstance.get("/rewards", { params });

const getDeletedRewards = async (params) =>
  await axiosInstance.get("/rewards", {
    params: { ...params, deleted_rewards: true },
  });

const addReward = async (data) => await axiosInstance.post("/rewards", data);

const getRewardDetails = async (id) =>
  await axiosInstance.get(`/rewards/${id}`);

const editReward = async ({ id, data }) =>
  await axiosInstance.patch(`/rewards/${id}`, data);

const deleteReward = async (id) => await axiosInstance.delete(`/rewards/${id}`);

const getRechargeAmounts = async () =>
  await axiosInstance.get("/rewards/amounts", {
    params: {
      reward_type: REWARDS_TYPES.chargingCard,
    },
  });

const getDiscountAmounts = async () =>
  await axiosInstance.get("/rewards/fawry_offers", {
    params: {
      offer_type: REWARDS_TYPES.discount,
    },
  });

const getVoucherAmounts = async () =>
  await axiosInstance.get("/rewards/fawry_offers", {
    params: {
      offer_type: REWARDS_TYPES.voucher,
    },
  });

const getRewardingReport = async () =>
  await axiosInstance.get(`/super_rewards/export_data`);

export {
  getRewards,
  addReward,
  getRewardDetails,
  editReward,
  deleteReward,
  getRechargeAmounts,
  getDiscountAmounts,
  getVoucherAmounts,
  getRewardingReport,
  getDeletedRewards,
};
